import React from 'react';
import classes from "./Circle.module.css";

const Circle = ({ number,colorChange,count }) => {
  return (
    <div className={`${classes.circle} ${colorChange ? classes.red : classes.blue} `}>
      <p>
        {number}
      </p>
      {count>0 && 
        <div className={`${classes.inside}`}>
          {count}
        </div>
      }
    </div>
  );
};

export default Circle;
